// src/components/profile/ProfileHeader.jsx
import React from 'react';
import { User, Building, IdCard } from 'lucide-react';

const ProfileHeader = ({ name, position, employeeId }) => {
  return (
    <div className="text-center mb-6">
      <div className="inline-block p-4 bg-gradient-to-br from-blue-50 to-indigo-50 rounded-2xl mb-4">
        <User className="h-12 w-12 text-blue-600" />
      </div>
      <h2 className="text-2xl font-bold text-gray-900">{name}</h2>
      <div className="flex flex-col items-center space-y-2 mt-3">
        <div className="flex items-center text-gray-600">
          <Building className="h-4 w-4 mr-2" />
          <span>{position}</span>
        </div>
        <div className="flex items-center text-gray-600">
          <IdCard className="h-4 w-4 mr-2" />
          <span className="font-mono">{employeeId}</span>
        </div>
      </div>
    </div>
  );
};

export default ProfileHeader;